import { useCallback, useEffect, useState } from 'react';

import queryString from 'query-string';
import { Spinner } from '@comeon/ui';
import { useLocation } from 'react-router-dom';

import useCheckLimits from '~/components/limits/hooks/use-check-limits';

import QuickDepositMobile from './quick-deposit-mobile';
import LimitsModal from '~/components/limits/modal';

const QuickDeposit = props => {
	const location = useLocation();
	const { check } = useCheckLimits();
	const [limitModal, showLimitModal] = useState(false);
	const queryParams = queryString.parse(location.search);
	const skipLimitsOnResult = !!queryParams?.accHistRef;
	const [limitsResolved, setLimitStatus] = useState(skipLimitsOnResult);

	const handleLimitsCheck = useCallback(async () => {
		const proceedWithDeposit = await check();

		if (!proceedWithDeposit) {
			showLimitModal(true);
		}
		setLimitStatus(true);
	}, [check]);

	useEffect(() => {
		if (!skipLimitsOnResult) {
			handleLimitsCheck();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (limitModal) {
		return <LimitsModal qdLimitsFlow />;
	}

	return limitsResolved ? <QuickDepositMobile {...props} /> : <Spinner />;
};

export default QuickDeposit;
